export type RenderMode = '2d' | '3d';

export function requestedRenderMode(): RenderMode {
	return new URLSearchParams(window.location.search).get('renderer') === '2d' ? '2d' : '3d';
}

export function usesMouseLook(): boolean {
	// Touch joysticks already update the player's angle; Pointer Lock would override their camera direction.
	return !window.matchMedia('(pointer: coarse)').matches;
}
